import React from 'react'
import styled from '@emotion/styled'
import { navigate } from 'gatsby'
import ColorButton from 'src/components/atoms/ColorButton'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { Image } from 'src/components/atoms/Image'

const PaperCard = ({ linkTo, imageFluid, subtitle }) => {
  const handleClick = () => navigate(linkTo)
  return (
    <Card onClick={handleClick}>
      <Thumbnail imageFluid={imageFluid} objectFit />
      <SubTitle as="h3">
        {subtitle.split('\n').map((str, index) => (
          <React.Fragment key={index}>
            {str}
            <br />
          </React.Fragment>
        ))}
      </SubTitle>
      <ButtonWrapper>
        <ColorButton text="ダウンロード" size="fill" to={linkTo} arrow />
      </ButtonWrapper>
    </Card>
  )
}

const Card = styled.div`
  padding-bottom: 10%;
  padding-top: 5%;
  width: 100%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Thumbnail = styled(Image)`
  margin: 0 auto;
  width: 86%;
  @media screen and (min-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 90%;
  }
`

const SubTitle = styled(Typography)`
  margin: 20px 0;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  padding: 0 15px;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.12px;
  text-align: center;
  color: #333333;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const ButtonWrapper = styled.div`
  padding: 0 10%;
`

export default PaperCard
